<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-plus"></i>
    </div>
    <div>
      <h2 class="dialog-title">{{ data.id !== -1 ? 'Edit Production Version' : 'New Production Version' }}</h2>
      <p class="dialog-subtitle">Fill in the production version details</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="versionForm" class="dialog-form-grid">
    <!-- Type -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Type <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="type" placeholder="Select type" [compareWith]="comparatorService.compareById">
          @for( versionType of versionTypes; track versionType ) {
            <mat-option [value]="versionType">{{ versionType | objectdesc }}</mat-option>
          }
        </mat-select>
        @if( versionForm.get('type')?.hasError('required') ) {
          <mat-error>Type is required</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Name -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Name <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="name" placeholder="Enter name">
        @if( versionForm.get('name')?.hasError('required') ) {
          <mat-error>Name is required</mat-error>
        }
        @if( versionForm.get('name')?.hasError('invalidcharacters') ) {
          <mat-error>Name has invalid characters</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Notes -->
    <div class="dialog-field-group dialog-form-grid-full">
      <mat-label class="mat-form-field-label">Notes</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="notes" placeholder="Enter notes">
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!versionForm.valid">
    {{ data.id !== -1 ? 'Update Version' : 'Create Version' }}
  </button>
</mat-dialog-actions>
